import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { StartupCard } from '@/components/Cards/StartupCard/v3';
import { useGetActiveBrands } from '@/query/queries/brand/useGetActiveBrands';
import { APP_LINKS } from '@/helpers/links';
import s from './index.module.scss';

export const BrandsActive = () => {
  const { t } = useTranslation('brands');
  const { data: brands } = useGetActiveBrands();
  const hasBrands = !!brands?.length;

  if (!hasBrands) {
    return null;
  }

  return (
    <div className={s.startups_active}>
      <h2 className="f-26 f-500">
        {t('startups.active.title', { value: brands.length })}
      </h2>
      <p className={classnames(s.startups_active__desc, 'f-16 f-400')}>
        {t('startups.active.description')}
      </p>
      {hasBrands ? (
        <div className={s.startups_active__list}>
          {brands.map(startup => (
            <StartupCard
              key={startup.id}
              startup={startup}
              href={APP_LINKS.startupDetail(startup.slug)}
              className={s.startups_active__card}
            />
          ))}
        </div>
      ) : (
        <div className={s.startups_active__empty}>
          <span
            className={classnames(s.startups_active__empty_title, 'f-16 f-400')}
          >
            {t('startups.active.no_brands')}
          </span>
        </div>
      )}
    </div>
  );
};
